export default "__VITE_ASSET__BtGQDFws__"